import 'bootstrap-select';
import {proceedSuccessNotice} from './notifier';

export function initScheduleDate(): void {
  $(document).off('click', '.schedule-button').on('click', '.schedule-button', e => {
    const $btnEle = $(e.currentTarget);
    const emailChainId = $(e.currentTarget).data('email-chain-id');
    const $toggledEle = $('.schedule-' + emailChainId);
    const isCandidatesTable = $btnEle.closest('#candidates-table').length > 0;

    if ($toggledEle.is(':visible')) {
      if (!isCandidatesTable) {
        $btnEle.removeClass('active');
      }

      if ($toggledEle.parent().parent().hasClass('all-candidates-schedule-form')) {
        $toggledEle.parent().hide()
      }
    } else {
      if (!isCandidatesTable) {
        $btnEle.addClass('active');
      }

      if ($toggledEle.parent().parent().hasClass('all-candidates-schedule-form')) {
        $toggledEle.parent().show()
      }
    }

    $toggledEle.toggle('fast');
  });

  $('.schedule-date').datepicker({
    format: "yyyy-mm-dd",
    clearBtn: true,
    autoclose: true,
    startDate: new Date(),
    todayHighlight: true
  })

  $(document).on("ajax:success", ".schedule-contact", function (event) {
    let emaiChainId = event.target.id.replace("edit_email_chain_", "")
    let $toggledEle = $(".schedule-" + emaiChainId);
    let $btnEle = $(".schedule-button-" + emaiChainId);
    let selectedDate = $toggledEle.find(".schedule-date").val();
    $toggledEle.hide()

    if ($toggledEle.parent().parent().hasClass('all-candidates-schedule-form')) {
      $toggledEle.parent().hide()
    }

    if(selectedDate) {
      $btnEle.removeClass('active').addClass('created');
      $btnEle.attr('title', `Follow-up scheduled for ${selectedDate}`);
    } else {
      $btnEle.removeClass('active').removeClass('created');
      $btnEle.attr('title', "Schedule follow-up");
    }
    proceedSuccessNotice(event.detail[0]);
  });

  // Initialize AI draft button handlers
  initAiDraftButtons();
}

function initAiDraftButtons(): void {
  $(document).off('click', '.ai-draft-button');

  $(document).on('click', '.ai-draft-button', function() {
    const emailChainId = $(this).data('email-chain-id');
    const button = this;

    button.disabled = true;
    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Generating...';

    $.ajax({
      url: `/email_chains/${emailChainId}/generate_ai_draft`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function(data) {
        const form = button.closest('form');
        if (!form) return;

        const subjectInput = form.querySelector('input[name="email_chain[follow_up_subject]"]');
        const bodyEditor = form.querySelector('.summernote');

        if (subjectInput) {
          (subjectInput as HTMLInputElement).value = data.subject;
        }

        if (bodyEditor) {
          if ($.fn.summernote) {
            $(bodyEditor).summernote('code', data.body);
          } else {
            (bodyEditor as HTMLInputElement).value = data.body;
          }
        }
      },
      error: function(xhr: any) {
        let errorMessage = 'Failed to generate AI response. Please try again.';
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = 'Error generating AI response: ' + xhr.responseJSON.error;
        }
        alert(errorMessage);
      },
      complete: function() {
        button.disabled = false;
        button.innerHTML = '<i class="fas fa-robot"></i> AI Draft Response';
      }
    });
  });
}
